import styled from 'styled-components';

export const StyledWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  gap: 16px;
  /* margin: 0 0 30px; */

  .fields-wrapper-holder {
    width: 100%;
    height: calc(100vh - 330px);
    border: 1px solid #e6e7ec;
    border-radius: 15px;
    overflow: hidden;

    @media (min-width: 1440px) {
      height: calc(100vh - 400px);
    }
  }

  .field-wrapper {
    width: 100%;
    height: 100%;
    display: flex;
    overflow: auto;
  }

  .col-holder {
    width: 50%;

    .col {
      width: 100%;
      min-height: 77px;
      display: flex;
      align-items: center;
      border-width: 0 0 1px 1px;
      border-style: solid;
      border-color: #e6e7ec;
      color: var(--text-color-50);
      text-align: center;
      padding: 15px 12px;
      margin: 0 0 -1px -1px;
      user-select: none;

      &.first-col {
        background: #fcfcfc;
      }

      &.add-new-col {
        display: flex;
        align-items: center;
        gap: 5px;
        color: var(--primary-color);
        border-width: 0 1px 1px 0;
        border-style: solid;
        border-color: #cdcdcd;
        position: relative;
        z-index: 2;
        margin: 0;
        cursor: pointer;

        .icon-holder {
          width: 18px;
          height: 18px;
          display: flex;
          align-items: center;
          justify-content: center;
          border: 1px solid var(--light-gray);
          border-radius: 50%;
        }
      }

      .heading {
        display: block;
        width: 100%;
        font-weight: 700;
        text-align: center;
      }

      span {
        display: block;
      }
    }

    &.search {
      border: 1px solid #e6e7ec;
      border-radius: 15px;
      overflow: hidden;

      .col {
        border-left: 0;

        &.search-col {
          display: flex;
          align-items: center;
          gap: 10px;
          padding: 11px 12px;
          background: #fcfcfc;

          .subtitle {
            display: block;
            flex-shrink: 0;
            font-size: 14px;
            line-height: 17px;
            font-weight: 500;
            color: #121212;
          }
        }
      }

      .columns {
        overflow: auto;
        height: calc(100vh - 408px);

        @media (min-width: 1440px) {
          height: calc(100vh - 480px);
        }
      }

      .search-holder {
        width: 100%;
        background: var(--white);
        position: relative;

        .search-icon {
          position: absolute;
          top: 50%;
          left: 10px;
          transform: translateY(-50%);
        }

        input {
          width: 100%;
          height: 45px;
          font-size: 13px;
          line-height: 16px;
          outline: none;
          border: none;
          padding: 10px 10px 10px 30px;
          border: 1px solid #e7e7e7;
          border-radius: 8px;
        }
      }
    }
  }

  .custom-field {
    border: none;
    outline: none;
    background: transparent;
  }
`;

export const StyledContainer = styled.div``;

export const StyledItem = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  line-height: 18px;
  text-align: left;
  padding: 12px 10px;
  border-radius: 6px;
  color: var(--blue);
  border: 1px solid var(--blue);
  cursor: grab;
  background: rgba(39, 131, 236, 0.1);

  .csv-col & {
    color: #115e59;
    border-color: #99f6e4;
    background: #f0fdfa;

    .icon-check {
      display: block;
    }
    .icon-coin {
      display: none;
    }
  }

  .text-box {
    flex-grow: 1;
  }

  .title {
    display: block;
    font-weight: 600;
    margin: 0 0 2px;
  }

  .text {
    display: block;
    font-weight: 700;
    color: var(--text-color-50);
  }

  .icon-coin {
    display: block;
    font-size: 20px;
  }
  .icon-check {
    display: none;
    font-size: 20px;
  }
  .icon-dots {
    display: block;
    font-size: 20px;
  }
`;
